var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartupsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 98,
    viewBox: "0 0 99 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.9727 49C98.9727 76.0589 77.0315 98 49.9727 98C22.9138 98 0.972656 76.0589 0.972656 49C0.972656 21.9411 22.9138 0 49.9727 0C77.0315 0 98.9727 21.9411 98.9727 49Z",
    fill: "#151514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.543 52.9167L37.1235 52.0907C36.2977 61.6121 40.9346 67.1307 50.2537 67.1307C56.1518 67.1307 62.9392 64.9069 62.9392 58.8165C62.9392 53.6156 58.3115 52.9802 50.3172 50.9471C40.1633 48.3421 34.5192 46.0003 34.5192 38.385C34.5192 31.7228 38.7659 25.823 50.2537 25.823C62.3041 25.823 67.7031 32.3582 67.7031 42.0701L62.1226 42.8326C62.1861 34.2642 58.0665 30.9059 50.1992 30.9059C42.332 30.9059 39.7913 34.3369 39.7913 38.0764C39.7913 41.4348 41.7604 43.3409 52.0322 45.6282C62.3767 47.979 68.2748 50.8291 68.2748 58.7621C68.2748 67.4575 61.1063 72.2136 50.6983 72.2136C37.06 72.2136 30.9713 63.963 31.543 52.9258",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupsIcon);
export default __webpack_public_path__ + "static/media/startupsIcon.0e9a70e5.svg";
export { ForwardRef as ReactComponent };var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStartupsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 98,
    viewBox: "0 0 99 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.9727 49C98.9727 76.0589 77.0315 98 49.9727 98C22.9138 98 0.972656 76.0589 0.972656 49C0.972656 21.9411 22.9138 0 49.9727 0C77.0315 0 98.9727 21.9411 98.9727 49Z",
    fill: "#151514"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.543 52.9167L37.1235 52.0907C36.2977 61.6121 40.9346 67.1307 50.2537 67.1307C56.1518 67.1307 62.9392 64.9069 62.9392 58.8165C62.9392 53.6156 58.3115 52.9802 50.3172 50.9471C40.1633 48.3421 34.5192 46.0003 34.5192 38.385C34.5192 31.7228 38.7659 25.823 50.2537 25.823C62.3041 25.823 67.7031 32.3582 67.7031 42.0701L62.1226 42.8326C62.1861 34.2642 58.0665 30.9059 50.1992 30.9059C42.332 30.9059 39.7913 34.3369 39.7913 38.0764C39.7913 41.4348 41.7604 43.3409 52.0322 45.6282C62.3767 47.979 68.2748 50.8291 68.2748 58.7621C68.2748 67.4575 61.1063 72.2136 50.6983 72.2136C37.06 72.2136 30.9713 63.963 31.543 52.9258",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupsIcon);
export default __webpack_public_path__ + "static/media/startupsIcon.0e9a70e5.svg";
export { ForwardRef as ReactComponent };